import { render, staticRenderFns } from "./InvoicePageTab.vue?vue&type=template&id=b12012b4&scoped=true&"
import script from "./InvoicePageTab.vue?vue&type=script&lang=ts&"
export * from "./InvoicePageTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12012b4",
  null
  
)

export default component.exports